// Promise-based in-app confirm dialog used to replace window.confirm().
//
//   const ok = await confirmDialog({ title, message, confirmText, danger });
//   if (!ok) return;
//
// Mount <ConfirmHost /> ONCE near the root of the app (App.js).
import React, { useEffect, useState } from 'react';

let setRequestFn = null;
const queue = [];

export const confirmDialog = (opts = {}) => new Promise((resolve) => {
  const req = {
    id: Math.random().toString(36).slice(2),
    title: opts.title || 'Are you sure?',
    message: opts.message || '',
    confirmText: opts.confirmText || 'Confirm',
    cancelText: opts.cancelText || 'Cancel',
    danger: !!opts.danger,
    resolve,
  };
  if (setRequestFn) setRequestFn(req);
  else queue.push(req);
});

export const ConfirmHost = () => {
  const [request, setRequest] = useState(null);

  useEffect(() => {
    setRequestFn = setRequest;
    // Flush anything queued before the host mounted
    if (queue.length) {
      const next = queue.shift();
      setRequest(next);
    }
    return () => { setRequestFn = null; };
  }, []);

  const close = (result) => {
    if (request) request.resolve(result);
    // If more requests are queued, surface the next one
    if (queue.length) setRequest(queue.shift());
    else setRequest(null);
  };

  if (!request) return null;

  return (
    <div
      data-testid="confirm-dialog-overlay"
      role="dialog"
      aria-modal="true"
      onClick={(e) => { if (e.target === e.currentTarget) close(false); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)',
        zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        data-testid="confirm-dialog"
        style={{
          width: '100%', maxWidth: 360, background: '#FFFFFF', borderRadius: 16,
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        <div style={{ padding: '20px 20px 8px' }}>
          <div data-testid="confirm-dialog-title" style={{ fontSize: 16, fontWeight: 700, color: '#0F172A', marginBottom: 6 }}>
            {request.title}
          </div>
          {request.message && (
            <div data-testid="confirm-dialog-message" style={{ fontSize: 14, color: '#475569', lineHeight: 1.5 }}>
              {request.message}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, padding: '12px 16px 16px', justifyContent: 'flex-end' }}>
          <button
            data-testid="confirm-dialog-cancel"
            onClick={() => close(false)}
            style={{
              padding: '10px 16px', borderRadius: 10, border: '1px solid #E2E8F0',
              background: '#FFFFFF', color: '#334155', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >
            {request.cancelText}
          </button>
          <button
            data-testid="confirm-dialog-confirm"
            onClick={() => close(true)}
            style={{
              padding: '10px 16px', borderRadius: 10, border: 'none',
              background: request.danger ? '#DC2626' : '#0EA5E9',
              color: '#FFFFFF', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >
            {request.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmHost;
